import { FC } from 'react';
import { CenteredSpinner } from 'src/shared/components/CenteredSpinner';
import { ConversationState } from 'src/shared/messaging-kit/hooks/useConversation';

export const MessageSpinner: FC<{ conversationState: ConversationState }> = ({
    conversationState,
}) => {
    if (
        [ConversationState.LOADING, ConversationState.LOADING_MORE_MESSAGES].includes(
            conversationState,
        )
    ) {
        return <CenteredSpinner />;
    }
    return null;
};
